import React from 'react';
import styled from 'styled-components';
import { RichText } from '@graphcms/rich-text-react-renderer';


const Wrapper = styled.span`
  font-size: 24px;
  line-height: 34px;
  padding-top: 61px;

  @media only screen and (max-width: 810px) {
    font-size: 16px;
    line-height: 20px;
    padding-top: 26px;
  }


  p {
    margin-bottom: 35px;
    @media only screen and (max-width: 810px) {
      margin-bottom: 30px;
    }
  }

  b {
    font-size: 54px;
    line-height: 1;
    line-height: 1;
    margin-right: 10px;
    display: block;
    font-family: ${({ theme }) => theme.fontSans};

    @media only screen and (max-width: 810px) {
      font-size: 36px;
      line-height: 1;
    }
  }

  a {
    text-decoration: none;
  }
`;

const NumbersRichText = ({ content, firstParMargin }) => {
  return (
    <Wrapper firstParMargin={firstParMargin}>
      <RichText content={content} />
    </Wrapper>
  );
};

export default NumbersRichText;
